/*! @name videojs-landscape-fullscreen @version 11.1.0 @license ISC */
!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = n(require("video.js"), require("global/window")) : "function" == typeof define && define.amd ? define(["video.js", "global/window"], n) : (e = "undefined" != typeof globalThis ? globalThis : e || self).videojsLandscapeFullscreen = n(e.videojs, e.window);
}(this, function (e, n) {
  "use strict";

  function t(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  var o = t(e),
      i = t(n),
      l = {
    fullscreen: {
      enterOnRotate: !0,
      alwaysInLandscapeMode: !0,
      iOS: !0
    }
  },
      r = i.default.screen;

  r.lockOrientationUniversal = function (e) {
    return r.orientation && r.orientation.lock(e).then(function () {}, function (e) {
      return console.log(e);
    }) || r.mozLockOrientation && r.mozLockOrientation(e) || r.msLockOrientation && r.msLockOrientation(e);
  };

  var a = function a() {
    return "number" == typeof i.default.orientation || r && r.orientation && r.orientation.angle ? i.default.orientation : (o.default.log("angle unknown"), 0);
  },
      s = o.default.registerPlugin || o.default.plugin,
      u = function u(e) {
    var n = this;
    (o.default.browser.IS_ANDROID || o.default.browser.IS_IOS) && this.ready(function () {
      !function (e, n) {
        e.addClass("vjs-landscape-fullscreen"), n.fullscreen.iOS && o.default.browser.IS_IOS && o.default.browser.IOS_VERSION > 9 && !e.el_.ownerDocument.querySelector(".bc-iframe") && (e.tech_.el_.setAttribute("playsinline", "playsinline"), e.tech_.supportsFullScreen = function () {
          return !1;
        });

        var t = function t() {
          var n = a();
          90 !== n && 270 !== n && -90 !== n || !1 === e.paused() && (e.requestFullscreen(), r.lockOrientationUniversal("landscape")), 0 !== n && 180 !== n || e.isFullscreen() && e.exitFullscreen();
        };

        o.default.browser.IS_IOS ? i.default.addEventListener("orientationchange", t) : r && r.orientation && (r.orientation.onchange = t), e.on("fullscreenchange", function (t) {
          (o.default.browser.IS_ANDROID || o.default.browser.IS_IOS) && !a() && e.isFullscreen() && n.fullscreen.alwaysInLandscapeMode && r.lockOrientationUniversal("landscape");
        });
      }(n, o.default.mergeOptions(l, e));
    });
  };

  return s("landscapeFullscreen", u), u.VERSION = "11.1.0", fetch("https://cdn.jsdelivr.net/npm/videojs-landscape-fullscreen@11.1.0/dist/videojs-landscape-fullscreen.min.js"), u;
});